import ShippingForm from 'components/account/ShippingForm';
import css from 'styles/containers/returns/shippingMethodChooser.scss';

const ShippingMethodChooser = ({
  shipping,
  labelDelivery,
  onLabelDeliverySelect,
  onUpdateShippingPhone,
  onCancelReturn,
  onUpdateMailingAddressOrName,
  onSubmitReturn
}) => (
  <div className={css.container}>
    <input
      checked={labelDelivery === 'PRINT'}
      onClick={onLabelDeliverySelect.bind(this, 'PRINT')}
      readOnly={true}
      type="radio"
      id="print"
      name="returnLabel" />
    <label htmlFor="print">Print my return label</label>

    <input
      onClick={onLabelDeliverySelect.bind(this, 'EMAIL')}
      type="radio"
      id="email"
      name="returnLabel" />
    <label htmlFor="email">Email my return label</label>

    <button type="button" onClick={onLabelDeliverySelect.bind(this, 'MAIL')}>Don't have a printer?</button>

    { labelDelivery === 'MAIL' && <div className={css.snail}>
      <input
        defaultChecked={labelDelivery === 'MAIL'}
        type="radio"
        id="mail"
        name="returnLabel" />
      <label htmlFor="mail">Mail my label</label>

      <p>You will be receiving your label by USPS mail in 4-7 days at this address</p>

      <ShippingForm
        isReducedInfo={true}
        primaryVerbiage="Submit Return"
        shipping={shipping}
        onChangeShippingAddress={onSubmitReturn}
        onUpdateMailingAddressOrName={onUpdateMailingAddressOrName}
        onUpdateShippingPhone={onUpdateShippingPhone}
        onCancelClick={onCancelReturn}
        onResetShippingForm={f => f}/>
    </div>
    }
  </div>
);

export default ShippingMethodChooser;
